
import React from 'react';
import { TeamOutlined, FileTextOutlined, ClusterOutlined, UserAddOutlined } from '@ant-design/icons';


const style={
    iconStyle:{
      fontWeight:800,
      fontSize:20
    }
  }

  const AuthenticateMenu=(permissions)=>{
 
    var Sidemenu = [
          // {
          //   title:'Dashboard',
          //   to:'/',
          //   type:'menu',
          //   icon:<LaptopOutlined style={style.iconStyle}/>,
          // }
      ]

  if(permissions.indexOf('Admin') != -1){
    //   Sidemenu.push( {
    //     title:'Create Organization',
    //     to:'/createOrganization',
    //     type:'menu',
    //     icon:<TeamOutlined style={style.iconStyle}/>,
    // })

      Sidemenu.push( {
        title:'Organizations',
        to:'/orgList',
        type:'menu',
        icon:<TeamOutlined style={style.iconStyle}/>,
    })


  }

  if(permissions.indexOf('Admin') != -1){
  //   Sidemenu.push( {
  //     title:'Create Subscriber',
  //     to:'/createSubscriber',
  //     type:'menu',
  //     icon:<TeamOutlined style={style.iconStyle}/>,
  // })
    Sidemenu.push( {
      title:'Subscriber',
      to:'/manageSubscriber',
      type:'menu',
      icon:<TeamOutlined style={style.iconStyle}/>,
  })
}

if(permissions.indexOf('Admin') != -1){
  Sidemenu.push({
    title: 'Create Staff',
    to: '/createStaff',
    type: 'menu',
    icon: <UserAddOutlined style={style.iconStyle} />,
  })
}

if(permissions.indexOf('Admin') != -1){
  Sidemenu.push({
    title: 'Devices',
    to: '/manageDevices',
    type: 'menu',
    icon: <ClusterOutlined style={style.iconStyle} />,
  })
}

if(permissions.indexOf('Admin') != -1){
  Sidemenu.push({
    title: 'Inventory',
    to: '/manageInventory',
    type: 'menu',
    icon: <ClusterOutlined style={style.iconStyle} />,
  })
}

if(permissions.indexOf('Admin') != -1 || permissions.indexOf('FormEngineOperator') != -1 || permissions.indexOf('FormSubscriber') != -1){
  Sidemenu.push({
    title: 'Form Designer',
    to: '/createTemplate',
    type: 'menu',
    icon: <ClusterOutlined style={style.iconStyle} />,
  })

  Sidemenu.push({
    title: 'Forms Master',
    type: 'submenu',
    key: 2, // -------------------Do Not Change ----------------------------
    icon: <FileTextOutlined style={style.iconStyle} />,
    children: [
      // {
      //   title: 'Create Form',
      //   to: '/createTemplate',
      // },
      {
        title: 'Forms List',
        to: '/manageForms',
      },
      {
        title: 'Sub Templates List',
        to: '/manageSubTemplates',
      },
      {
        title: 'Questions List',
        to: '/createQuestion',
      },
    ]
  })
}

if(permissions.indexOf('Admin') != -1 || permissions.indexOf('FormEngineOperator') != -1 ){
    Sidemenu.push({
      title: 'Order Sets',
      type: 'submenu',
      icon: <FileTextOutlined style={style.iconStyle} />,
      children: [
        {
          title: 'List',
          to: '/manageOrdersets',
        },
        {
          title: 'Create',
          to: '/createOrdersets',
        },
      ]
    })
}


if(permissions.indexOf('Admin') != -1 || permissions.indexOf('FormEngineOperator') != -1 ){
 let mm = Sidemenu.find((m)=>m.key == 2)
 if(mm){
   mm.children.push({
    title: 'Notifications',
    to: '/notifications',
   })
 }
}

if(permissions.indexOf('FormSubscriber') != -1 ){
  Sidemenu.push( {
    title:'Settings',
    to:'/settings',
    type:'menu',
    icon:<TeamOutlined style={style.iconStyle}/>,
})
}
 
      return Sidemenu
  }


  export default AuthenticateMenu;